import { IAuthToken } from '@/types/models/auth';

interface ITeamIdInformation {
  teamId: string;
  userId: string;
}

const KEYS = {
  USER: 'localUser',
  LANGUAGE: 'selectedLanguage',
  INVITATION_CODE: 'invitationCode',
  TEAM_ID: 'teamId',
  INTENDED_DESTINATION: 'intendedDestination',
};

export const storeTeamId = (teamId: ITeamIdInformation): void => {
  setItem(KEYS.TEAM_ID, teamId);
};

export const storeLanguage = (language: string): void => {
  setItem(KEYS.LANGUAGE, language);
};

// STORE LOCAL DATA
export const storeLocalUser = (user: IAuthToken): void => {
  setItem(KEYS.USER, user);
};

// STORE LOCAL INVITATION_CODE
export const storeLocalInvitationCode = (code: string): void => {
  setItem(KEYS.INVITATION_CODE, code);
};

// STORE INTENDED DESTINATION
export const storeIntendedDestination = (destination: string): void => {
  setItem(KEYS.INTENDED_DESTINATION, destination);
};

// LOAD FROM LOCAL DATA
export const loadTeamId = (): ITeamIdInformation | null => {
  try {
    const dataString = localStorage.getItem(KEYS.TEAM_ID);
    return dataString ? JSON.parse(dataString) : null;
  } catch {
    return null;
  }
};

export const loadLocalUser = (): IAuthToken => {
  return getItem(KEYS.USER);
};

export const loadLanguage = (): string | null => {
  try {
    const dataString = localStorage.getItem(KEYS.LANGUAGE);
    return dataString ? JSON.parse(dataString) : null;
  } catch {
    return null;
  }
};

export const loadInvitationCode = (): string | null => {
  try {
    const dataString = localStorage.getItem(KEYS.INVITATION_CODE);
    return dataString ? JSON.parse(dataString) : null;
  } catch {
    return null;
  }
};

export const loadIntendedDestination = (): string | null => {
  try {
    const dataString = localStorage.getItem(KEYS.INTENDED_DESTINATION);
    return dataString ? JSON.parse(dataString) : null;
  } catch {
    return null;
  }
};

// CLEAR LOCAL DATA
export const clearTeamId = (): void => {
  removeItem(KEYS.TEAM_ID);
};

export const clearLocalUser = (): void => {
  removeItem(KEYS.USER);
};

export const clearLanguage = (): void => {
  removeItem(KEYS.LANGUAGE);
};

export const clearInvitationCode = (): void => {
  removeItem(KEYS.INVITATION_CODE);
};

export const clearIntendedDestination = (): void => {
  removeItem(KEYS.INTENDED_DESTINATION);
};

// PRIVATE
const getItem = (key: string): any => {
  try {
    const dataString = localStorage.getItem(key);

    return dataString ? JSON.parse(dataString) : {};
  } catch {
    return {};
  }
};

const setItem = (key: string, data: any): void => {
  localStorage.setItem(key, JSON.stringify(data));
};

const removeItem = (key: string): void => {
  localStorage.removeItem(key);
};
